import AlertBanner from 'tio-ui/components/alert-banner';
import Component from '@glimmer/component';
import { t } from 'ember-intl';

interface S {
  Blocks: {
    default: [];
  };
  Element: HTMLDivElement;
}

// temp alert component for the 2025 budget reconciliation bill messing with our tools
// NB: remember to delete translations strings when this invariably gets deleted
// - james 20250717
export default class BudgetReconciliationBillAlert extends Component<S> {
  <template>
    <AlertBanner @intent="info" ...attributes>
      <h2 class="text-base"><strong>{{t "budget_reconciliation_bill_alert.header"}}</strong></h2>
      <p>{{t "budget_reconciliation_bill_alert.body"}}</p>
    </AlertBanner>
  </template>
}
